import {
  Box,
  Flex,
  JaneGoldIcon,
  TagFilledIcon,
  Typography,
} from '@jane/shared/reefer';

export interface SpecialDetailStatusCTAProps {
  calloutSubtext?: string;
  calloutText: string;
  isGold: boolean;
}

export const SpecialDetailStatusCTA = ({
  calloutSubtext,
  calloutText,
  isGold,
}: SpecialDetailStatusCTAProps) => {
  if (!calloutText) return null;

  return (
    <Flex alignItems="center">
      <Box
        background={isGold ? 'gold-light' : 'info-light'}
        borderRadius="xs"
        p={12}
      >
        {isGold ? <JaneGoldIcon /> : <TagFilledIcon color="info" />}
      </Box>

      <Box ml={16}>
        <Typography variant="body-bold">{calloutText}</Typography>
        {calloutSubtext && (
          <Typography variant="mini" color="grays-mid">
            {calloutSubtext}
          </Typography>
        )}
      </Box>
    </Flex>
  );
};
